import React from 'react'
import { SvgIcon } from '@mui/material'

export const EventWappIcon = props => (
  <SvgIcon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 4h-2V3a1 1 0 0 0-2 0v1H9V3a1 1 0 0 0-2 0v1H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3Zm1 15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-7h16v7Zm0-9H4V7a1 1 0 0 1 1-1h2v1a1 1 0 0 0 2 0V6h6v1a1 1 0 0 0 2 0V6h2a1 1 0 0 1 1 1v3Z"
      fill="url(#EventWappIcon)"
    />
    <defs>
      <linearGradient
        id="EventWappIcon"
        x1="2.032"
        y1="2.251"
        x2="16.986"
        y2="25.495"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B09B" />
        <stop offset="1" stopColor="#96C93D" />
      </linearGradient>
    </defs>
  </SvgIcon>
)
